







import { Component, Vue } from 'vue-property-decorator'

import NotificationBar from '@/components/layouts/app/NotificationBar.vue'

@Component({ components: { NotificationBar } })
class PlainTemplate extends Vue {}

export default PlainTemplate
